const snackbarProps = state => state.snackbar;

export default snackbarProps;
